import { Box } from "@mui/material";
import { getImageUrl } from "@app/helpers/getUploadUrl";
import SortableList, { SortableItem } from "react-easy-sort";
import { useNavigate } from "react-router-dom";

import { useProductOrderingLogic } from "./useProductOrderingLogic";
import { StyledDrag } from "./styled";

const ProductOrdering = () => {
  const navigate = useNavigate();
  const { productList, onSortEnd } = useProductOrderingLogic()

  return (
    <Box>
      <Box
        sx={{ mb: 5, cursor: 'pointer' }}
        onClick={() => {
          navigate(-1)
        }}
      >
        Go Back
      </Box>

      <SortableList
        onSortEnd={onSortEnd}
        lockAxis="y"
        draggedItemClassName="dragged"
      >
        {
          productList.map((item, index) => {
            return (
              <SortableItem key={item.id}>
                <StyledDrag>
                  <p>{index + 1}</p>
                  <Box
                    display="flex"
                    flexDirection="column"
                    sx={{ cursor: 'grab', width: 100 }}
                  >
                    <img
                      src={getImageUrl(item.images[0].url)}
                      width={100}
                      alt="product"
                    />
                    {item.titleAm}
                  </Box>
                </StyledDrag>
              </SortableItem>
            )
          })
        }
      </SortableList>
    </Box>
  )
};

export default ProductOrdering;
